<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">生活缴费</div>
      </div>
      <div class="haerd_right"></div>
    </div>

    <div class="module_box">
      <div class="health" @click.stop.prevent="goWater">
        <div class="module_left">水费缴费</div>

        <div class="module_right_icon1 Water1">
          <div class="module_right_icon2 Water2">
            <div class="module_right_icon3 Water3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goElectricity">
        <div class="module_left">电费缴费</div>

        <div class="module_right_icon1 Electricity1">
          <div class="module_right_icon2 Electricity2">
            <div class="module_right_icon3 Electricity3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goGas">
        <div class="module_left w180">燃气费缴费</div>

        <div class="module_right_icon1 Gas1">
          <div class="module_right_icon2 Gas2">
            <div class="module_right_icon3 Gas3"></div>
          </div>
        </div>
      </div>

      <div class="health" @click.stop.prevent="goPhone">
        <div class="module_left">手机话费充值</div>

        <div class="module_right_icon1 Phone1">
          <div class="module_right_icon2 Phone2">
            <div class="module_right_icon3 Phone3"></div>
          </div>
        </div>
      </div>

      <div class="health" @click.stop.prevent="goTelevision">
        <div class="module_left w180">有线电视费缴费</div>

        <div class="module_right_icon1 Television1">
          <div class="module_right_icon2 Television2">
            <div class="module_right_icon3 Television3"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  beforeDestroy() {},

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    async goWater() {
      this.$router.push({
        path: "/life/water/index",
      });
    },
    async goElectricity() {
      this.$router.push({
        path: "/life/electricity/index",
      });
    },
    async goGas() {
      this.$router.push({
        path: "/life/gas/index",
      });
    },
    async goPhone() {
      this.$router.push({
        path: "/life/phone/index",
      });
    },
    async goTelevision() {
      this.$router.push({
        path: "/life/television/index",
      });
    },
    async goBack() {
      this.$router.replace({
        path: "/classification",
      });
    },
  },
};
</script>

<style scoped lang="less">
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  /* 线性渐变 */
  background: linear-gradient(
    180deg,
    rgb(255, 108, 108) 6.107%,
    rgb(255, 150, 150) 20.611%,
    rgb(255, 247, 228) 99.237%
  );
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/colorBg/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/colorBg/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 44px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 40px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 45vw;
      color: #ffffff;
      line-height: 1.2;
    }
  }
  .haerd_right {
    position: absolute;
    right: 50px;
    top: 40px;
    z-index: 0;
    width: 307px;
    height: 250px;
    background: url(@/assets/life/lifeIndex/lifeIndex_subscript.png) no-repeat
      center;
    background-size: 100% 100%;
  }
}

.module_box {
  // width: 100%;
  // margin: 0 40px 0;
  position: absolute;
  top: 340px;
  max-height: 910px;
  overflow-y: auto;
  padding-right: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 0 35px;
  .health {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    // flex-direction: column;
    align-items: center;
    width: 325px;
    height: 150px;
    background: #ffffff;
    border-radius: 15px;
    margin-bottom: 20px;
    margin-right: 20px;
    .module_left {
      display: flex;
      // justify-content: center;
      margin-left: 20px;
      align-items: center;
      width: 150px;
      // height: 71px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 33px;
      letter-spacing: 2px;
      color: #333333;
      // margin-left: 20px;
      z-index: 99;
    }
    .w180 {
      width: 180px;
    }
    .module_right_icon1 {
      width: 250px;
      height: 253px;
      position: absolute;
      right: -25%;
      top: -50%;
      .module_right_icon2 {
        width: 130px;
        height: 117px;
        position: absolute;
        left: 22%;
        bottom: 4.5%;
        .module_right_icon3 {
          width: 70px;
          height: 70px;
          position: absolute;
          left: 13.5%;
          top: 23.5%;
        }
      }
    }
  }
  .health:nth-child(2n) {
    margin-right: 0;
  }
  .Water1 {
    background: url("@/assets/colorBg/green1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Water2 {
    background: url("@/assets/colorBg/green2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Water3 {
    background: url("@/assets/life/lifeIndex/water.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Electricity1 {
    background: url("@/assets/colorBg/blue1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Electricity2 {
    background: url("@/assets/colorBg/blue2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Electricity3 {
    background: url("@/assets/life/lifeIndex/electricity.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Gas1 {
    background: url("@/assets/colorBg/pink1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Gas2 {
    background: url("@/assets/colorBg/pink2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Gas3 {
    background: url("@/assets/life/lifeIndex/gas.png") no-repeat center;
    background-size: 100% 100%;
  }
  .phone1 {
    background: url("@/assets/colorBg/orange1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Phone2 {
    background: url("@/assets/colorBg/orange2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Phone3 {
    background: url("@/assets/life/lifeIndex/phone.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Television1 {
    background: url("@/assets/colorBg/purple1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Television2 {
    background: url("@/assets/colorBg/purple2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Television3 {
    background: url("@/assets/life/lifeIndex/television.png") no-repeat center;
    background-size: 100% 100%;
  }
}

.prompt {
  width: 100%;
  position: absolute;
  bottom: 2vh;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
</style>
